module.exports = "/_next/static/images/bfe5ba5d12ff6f131a6bfbb17fcd2773-holding-device-smile-2@0.5x.jpg";